import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'enabled-popup',
  templateUrl: './enabled-popup.component.html',
  styleUrls: ['./enabled-popup.component.less', '../../shared/common.less']
})
export class EnabledPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Input() contactEnabled: string = "";

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  ngOnInit() {}
}
